import { Subscription } from "rxjs";
import { DataSource, SortModel, FilterModel, FetchDataResult, FetchErrorResult } from "./DataSource";
import { QueryParams, Pagination, WebApiActionGet, WebApiItems } from "../ajax/WebApi";
import { isFunction } from "../utils";

declare type WebApiActionGetTypeFunc<T> = () => WebApiActionGet<WebApiItems<T>>;
declare type WebApiActionGetType<T> = WebApiActionGet<WebApiItems<T>> | WebApiActionGetTypeFunc<T>;// WebApiActionGet<WebApiItems<T>>;


export class WebApiDataSource<T> extends DataSource<T> {

    private action: WebApiActionGetType<T>;
    private actionSubscription: Subscription;

    constructor(action: WebApiActionGetType<T>) {
        super();

        this.action = action;
    }

    private getQueryParams = (): QueryParams => {

        let pagination: Pagination = null;
        let filter: string = null;
        let orderby: string = null;

        if (this.state.pageSize && this.state.pageSize > 0) {
            pagination = { page: this.state.currentPage, pageSize: this.state.pageSize }
        }

        if (this.state.sortedItems !== undefined) {
            const sortedKeys = Object.keys(this.state.sortedItems);
            if (sortedKeys.length > 0) {
                const orderbyArray: Array<string> = [];
                sortedKeys.map(x => {
                    const sd = this.state.sortedItems[x];
                    const dir = sd.direction === 'desc' ? ' desc' : '';
                    orderbyArray.push(`${x}${dir}`);
                });
                orderby = orderbyArray.join(",");
            }
        }

        if (this.state.filteredItems !== undefined) {
            const filteredKeys = Object.keys(this.state.filteredItems);
            if (filteredKeys.length > 0) {
                const filterArray: Array<string> = [];
                filteredKeys.map(x => {
                    const sd = this.state.filteredItems[x];
                    let val = sd.value.toString();
                    if (val !== undefined) {
                        switch (sd.operator) {
                            case 'contains':
                            case 'startswith':
                            case 'endswith':
                                filterArray.push(`${sd.operator}(${x},'${val}')`);
                                break;
                            default:
                                filterArray.push(`${x} ${sd.operator} ${val}`);
                                break;
                        }
                    }
                });
                filter = filterArray.length > 0 ? "(" + filterArray.join(") or (") + ")" : null;
            }
        }


        return <QueryParams>{
            pagination: pagination,
            filter: filter,
            orderby: orderby
        }
    }

    private unsubsribe = () => {
        if (this.actionSubscription !== undefined) {
            this.actionSubscription.unsubscribe();
            this.actionSubscription = undefined;
        }
    }

    protected fetchData(): void {
        const queryParams = this.getQueryParams();

        this.unsubsribe();

        let action: WebApiActionGet<WebApiItems<T>>;
        if (isFunction(this.action)) {
            action = (this.action as WebApiActionGetTypeFunc<T>)();
        } else {
            action = this.action as WebApiActionGet<WebApiItems<T>>;
        }

        action
            .onSuccess(x => this.fetchSuccess({ data: x.Items, itemsCount: x.Count }))
            .onError(e => this.fetchError({ errorMsg: e.message }));


        this.actionSubscription = action.getExecute$()
            .subscribe(
                result => {
                    this.unsubsribe();
                    action.handleSuccess(result);
                },
                error => {
                    this.unsubsribe();
                    action.handleError(error);
                });

        action.execute(queryParams);
    }
}
